// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3lM8s","content":"LayoutSettings_content__3W24W"};